import axios from 'axios'
export function getNotifications({ state, commit }, prop) {
    var params = {
        "userId": prop.user_id,
	    "per_page": 10
    }
    return new Promise((resolve, reject) => {
        axios
            .post(`/notification/list?page=${prop.page}`, params)
            .then(response => {
                resolve(response.data.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}
export function resetStore({ commit, store }) {
    commit('resetStore')
}